import { ME } from "../types";

export const userReducer = (
  state = { isLoading: true, data: {} },
  action: { type: any; payload: any }
) => {
  switch (action.type) {
    case ME:
      return {
        isLoading: false,
        data: action.payload,
      };
    default:
      return state;
  }
};
